module.exports = __webpack_public_path__ + "static/media/29.b06d0b92.mp3";